import { Box, Card, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import pdfLogo from "../../../../assets/images/pdf-icon-4.png";
import { DataGrid } from "@mui/x-data-grid";
import NoRowsLayout from "../../../../components/Layout/NoRowsLayout";
import Loading from "../../../../components/Loader/Loading";
import { ProviderServices } from "../../CrudServices";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { formatDateTime } from "../../../../utils/dateUtils";
const SubscriptonFee = () => {
  
    const {id} = useParams();
    const downloadInvoice = async (transactionId) => {
      Swal.fire({
        title: 'Generating Invoice...',
        html: 'Please wait while the invoice is being generated.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      const response = await ProviderServices.downloadSubscriptionInvoice({
        id: transactionId,
        expertId: id
      });
      if(response.success){
        // {
        //     "success": true,
        //     "fileUrl": "https://cudel.s3.amazonaws.com/staging/pdf/subscriptionInvoice/INV-65_28_1766542878400.pdf"
        // }
        const result =await Swal.fire({
          title: 'Invoice Generated',
          text: 'Your invoice has been generated successfully.',
          icon: 'success',
          confirmButtonText: 'View Invoice',
          allowOutsideClick: false,
        })
        if(result.isConfirmed){
          window.open(response.fileUrl, '_blank');
        }
      }else{
        Swal.fire({
          title: 'Error',
          text: 'Failed to generate invoice. Please try again later.',
          icon: 'error',
          confirmButtonText: 'OK'
        });
      }
    };
    const columns = [
      { field: "id", headerName: "ID", flex: 0.3, sortable: false,headerAlign: "center",
        renderCell: (params) => (
          <Box sx={{ width: "100%",textAlign:'center' }}>
            <Typography sx={{ fontSize: "0.65rem" }}>
              {params.value}
            </Typography>
          </Box>
        ),
      },
      {
        field: "subscription",
        headerName: "Title",
        flex: 2,
        headerAlign: "center",
        sortable: false,
        renderCell: (params) => (
          <Box sx={{ width: "100%",textAlign:'center' }}>
            <Typography sx={{ fontSize: "0.65rem" }}>
              Subscription Slab : {params.row.orderStart} - {params.row.orderEnd}
            </Typography>
          </Box>
        ),
      },
      {
        field: "createdAt",
        headerName: "Month",
        flex: 1,
        headerAlign: "center",
        sortable: false,
        renderCell: (params) => (
          <Box sx={{ width: "100%",textAlign:'center' }}>
            <Typography sx={{ fontSize: "0.65rem" }}>
              {new Date(params.row.createdAt).toLocaleString('en-IN', { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit', timeZone: 'Asia/Kolkata', timeZoneName: 'short' })}
            </Typography>
          </Box>
        ),
      },
      {
        field: "subscriptionFee",
        headerName: "Base Fee",
        flex: 1,
        headerAlign: "center",
        sortable: false,
        renderCell: (params) => (
          <Box sx={{ width: "100%",textAlign:'center' }}>
            <Typography sx={{ fontSize: "0.65rem" }}>
              ₹ {params.value.toFixed(2)}
            </Typography>
          </Box>
        ),
      },
      {
        field: "subscriptionFeeWithGst",
        headerName: "Total Fee",
        flex: 1,
        headerAlign: "center",
        sortable: false,
        renderCell: (params) => (
          <Box sx={{ width: "100%",textAlign:'center' }}>
            <Typography sx={{ fontSize: "0.65rem" }}>
              ₹ {params.value.toFixed(2)}
            </Typography>
          </Box>
        ),
      },
      {
        field: "actions",
        headerName: "Download Invoice",
        flex: 0.5,
        headerAlign: "center",
        sortable: false,
        renderCell: (params) => (
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 1,
              p:1
            }}
          >
            <img
              src={pdfLogo}
              alt="download_pdf_logo"
              style={{ width: "2rem", height: "2rem", cursor: "pointer" }}
              onClick={() => downloadInvoice(params.row.id)}
            />
          </Box>
        ),
      },
    ];
    const [rowdata, setRowData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [allRowCount, setAllRowCount] = useState(0);
    const [paginationModel, setPaginationModel] = useState({
      page: 0,
      pageSize: 5,
      filters: {
          // searchKey: '',
          sortKey: '',
          sortDirection: 'desc',
          // filterOptions: [],
      },
    });
    const handlePaginationChange = (newPagination) => {
        setPaginationModel({
          ...paginationModel,
          page: newPagination.page,
          pageSize: newPagination.pageSize
        });
    };
    const fetchSubscriptionFeeTransactions = async() => {
      setLoading(true);
      const response = await ProviderServices.getSubscriptionFeeTransactions(paginationModel,id);
      console.log("Subscription Fee Transactions Response:", response);
      if(response.success == '1'){
        setRowData(response.data);
        setAllRowCount(response.totalItems);
      }else if(response.success == '0'){
        setRowData([]);
        setAllRowCount(0);
      }
      setLoading(false);
    }
    useEffect(()=>{
      if(id){
        fetchSubscriptionFeeTransactions();
      }
    },[id,paginationModel])
  return (
    <Grid item xs={12}>
      <Card>
        <Box
          sx={{
            p: ".5% 1%",
            border: "2px solid lightGray",
            bgcolor: "lightGray",
          }}
        >
          <Typography sx={{ fontWeight: "600", fontSize: "0.85rem" }}>
            Subscription Fee Info
          </Typography>
        </Box>
        <Box sx={{ overflow: "auto" }}>
          <Box
            sx={{
              width: "100%",
              display: "table",
              tableLayout: "fixed",
              backgroundColor: "#fff",
              borderRadius: ".5rem",
              "& .odd": {
                bgcolor: "white",
              },
              "& .even": {
                bgcolor: "#ECECEC",
              },
            }}
          >
            <DataGrid
              rows={rowdata}
              columns={columns.map((col) => ({
                ...col,
                flex: col.flex || 1, // Ensure columns resize dynamically
                minWidth: col.minWidth || 180, // Set a minimum width to avoid overlap
              }))}
              // getRowId={(row) => row.id}
              //checkboxSelection={true}
              rowCount={allRowCount} // Use the length of the filtered list
              pageSizeOptions={[5, 10, 20, 50, 100]}
              paginationModel={paginationModel}
              paginationMode="server"
              onPaginationModelChange={handlePaginationChange}
              //   filterModel={filterModel}
              loading={loading}
              disableColumnMenu
              disableRowSelectionOnClick
              // disableColumnFilter
              // disableColumnSelector
              disableDensitySelector
              slots={{
                // toolbar: GridToolbar,
                noRowsOverlay: () => (
                  <NoRowsLayout message={"No Transactions Found"} />
                ),
                loadingOverlay: Loading,
              }}
              // slotProps={{
              //   toolbar: {
              //     showQuickFilter: true,
              //   },
              // }}
              // rowHeight={50}
              autoHeight
              getRowHeight={() => "auto"}
              sx={{
                "& .MuiDataGrid-cell": {
                  border: 1,
                  borderRight: 0,
                  borderTop: 0,
                  borderColor: "lightgrey",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                },
                "& .MuiDataGrid-columnHeaders": {
                  borderBottom: "2px solid rgba(224, 224, 224, 1)",
                  borderTop: "2px solid rgba(224, 224, 224, 1)",
                  fontWeight: 600,
                  fontSize: "0.75rem",
                  p: 0,
                  height: "fit-content",
                  minHeight: "0 !important",
                  height: "2rem",
                },
                "& .MuiDataGrid-columnHeader": {
                  borderLeft: "1px solid rgba(224, 224, 224, 1)",
                  "&:last-child": {
                    borderRight: "none",
                  },
                },
                "& .MuiDataGrid-columnHeaderTitle": {
                  fontWeight: 600,
                  color: "#3e3e3e",
                },
                "& .MuiDataGrid-row": {
                  "&:last-child .MuiDataGrid-cell": {
                    borderBottom: "1px solid rgba(224, 224, 224, 1)",
                  },
                  "& .MuiDataGrid-cell:last-child": {
                    borderRight: "none",
                  },
                },
                "& .MuiDataGrid-columnSeparator": {
                  display: "none",
                },
              }}
            />
          </Box>
        </Box>
      </Card>
    </Grid>
  );
};

export default SubscriptonFee;
